$('#show-form').on('click', function(){
	$('#review-form').slideToggle('#review-form');
	$("i", this).toggleClass("fa-angle-up fa-angle-down");
});

$('.kv-ltr-theme-fa-star').rating({
	hoverOnClear: false,
	theme: 'krajee-fa',
	step: 1, 
	});

var offset = 5;

$('#load-more-testimonials').on('click', function(e){
	$('.loader').fadeIn();
	$(this).hide();
	e.preventDefault();

	var count = 10;
	var data_form = {
		'action': 'load_testimonials',
		'data': {
			'offset': offset, 
			'count': count,
		},
	};
	/*eslint-disable */
	$.ajax({
		url: surepress.ajax_url,
		method: 'POST',
		dataType: 'html',
		data: data_form,
		success: function(response){
			$('.review-entry').last().after(response);
			$('.loader').hide();
			offset += count;

			if( offset < $('#testimonial-total').attr('data-attr') ){
				$('#load-more-testimonials').fadeIn();
			}
		},
		error: function(error){
			$('.loader').hide();
			console.log(error);
		}
	});
	/*eslint-enable */
});

var form_id = $('#review-form').find('form').attr('id');
var arr = new Array();

$('#review-form .gfield_contains_required input, #review-form .gfield_contains_required textarea, #review-form .kv-ltr-theme-fa-star').each(function() {
	arr.push(this.id);
});

$('#'+$('#review-form').find('input[type="submit"]').attr('id')).on('click', function(e){
	if(checkValid()){
		$('#'+form_id).submit();
	}else{
		e.preventDefault();
	}		
});


var checkValid = function(){
	var response = true;
	$.each(arr, function(index,val){
		if( $('#'+val).val().length  === 0){
			$('#'+val).parent().closest('li').addClass('gfield_error');
			if(!$('#'+val).parent().closest('li').find('.gfield_description').length){
				$('#'+val).parent().closest('.ginput_container').after('<div class="gfield_description validation_message">This field is required.</div>');
				$('#'+val).parent().closest('.rating-container').after('<div class="gfield_description validation_message">This field is required.</div>');	
			}
			response = false;
		}else{
			$('#'+val).parent().closest('li').removeClass('gfield_error');
			if($('#'+val).parent().closest('li').find('.gfield_description').length){
				$('#'+val).parent().closest('li').find('.gfield_description').remove();
			}
		}
	});
	return response;
}


// WEBPACK FOOTER //
// ./scripts/includes/testimonials.js